// AI Generated Test
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { PAGE_FIX_EVENT } from '../../constants/page-fix-event';
import { PAGE_FIX_FORM_VIEW_NAME } from '../../constants/page-fix-form-view-name';
import { PAGE_FIX_FORM_VIEW_TYPE } from '../../constants/page-fix-form-view-type';
import { PageFixModelHelper } from '../../services/model-helper/page-fix-model-helper';
import PAGE_FIX_ACCESSIBILITY_CHECK_CONFIG from '../../constants/page-fix-accessibility-check-config.json';

@Component({
    selector: 'page-fix-form-skip-to-content',
    templateUrl: './skip-to-content.component.html',
    standalone: false,
})
export class PageFixFormSkipToContentComponent implements OnInit, OnDestroy {
    @Input() resolve: any;
    @Output() close = new EventEmitter<any>();
    @Output() dismiss = new EventEmitter<any>();

    goToViewId = 0;
    updatePageFixId = 0;
    pageFix: any;
    pageFixId: any;
    pageFixSelector = '';
    infoViewType: any;
    optionsViewType: any;
    testingViewType: any;

    constructor (
        private monEventService: MonEventService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    ngOnDestroy (): void {
        this.monEventService.remove(this.goToViewId);
        this.monEventService.remove(this.updatePageFixId);
    }

    activate (): void {
        this.goToViewId = 0;
        this.updatePageFixId = 0;
        this.pageFix = this.resolve.pageFix;
        this.pageFixId = this.resolve.typeId || this.resolve.model.id;
        this.pageFixSelector = JSON.stringify([
            PageFixModelHelper.getSelectorValue(PAGE_FIX_ACCESSIBILITY_CHECK_CONFIG[this.pageFixId].snippet),
        ]);
        this.infoViewType = PAGE_FIX_FORM_VIEW_TYPE.INFO;
        this.optionsViewType = PAGE_FIX_FORM_VIEW_TYPE.OPTIONS;
        this.testingViewType = PAGE_FIX_FORM_VIEW_TYPE.TESTING;

        this.setupListeners();
    }

    setupListeners (): void {
        this.goToViewId = this.monEventService.addListener(PAGE_FIX_EVENT.FORM_REQUEST_GO_TO_VIEW, () => {
            this.setView(PAGE_FIX_FORM_VIEW_NAME.OPTIONS);
        });

        this.updatePageFixId = this.monEventService.addListener(PAGE_FIX_EVENT.UPDATE_PAGEFIX, (pageFix: any) => {
            this.pageFix = pageFix;
        });
    }

    setView (viewName: string): void {
        this.monEventService.run(PAGE_FIX_EVENT.FORM_UPDATE_VIEW, viewName);
    }

    closeModal (pageFix: any): void {
        this.close.emit({ $value: pageFix });
    }
}
